'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LoggedOutView = require('./LoggedOutView.jsx');

var _LoggedOutView2 = _interopRequireDefault(_LoggedOutView);

var _LoggedInView = require('./LoggedInView.jsx');

var _LoggedInView2 = _interopRequireDefault(_LoggedInView);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

    _this.state = {
      ready: false,
      loggedIn: false,
      user: {}
    };
    _this.didAuthenticate = _this.didAuthenticate.bind(_this);
    _client2.default.authenticate().then(function (user) {
      _this.setState({
        ready: true,
        loggedIn: true,
        user: user.data
      });
    }).catch(function (error) {
      _this.setState({ ready: true });
      if (!error.message.match(/stored JWT/)) {
        console.error(error);
      }
    });
    return _this;
  }

  _createClass(App, [{
    key: 'didAuthenticate',
    value: function didAuthenticate(user) {
      console.log(user);
      this.setState({
        user: user,
        loggedIn: true
      });
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      this.setState({
        user: null,
        loggedIn: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.ready) {
        if (this.state.loggedIn) {
          return _react2.default.createElement(_LoggedInView2.default, { user: this.state.user });
        } else {
          return _react2.default.createElement(_LoggedOutView2.default, { didAuthenticate: this.didAuthenticate });
        }
      } else {
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
    }
  }]);

  return App;
}(_react2.default.Component);

exports.default = App;


//////////////////
// WEBPACK FOOTER
// ./client/components/App.jsx
// module id = 214
// module chunks = 0